/* eslint-disable camelcase */
import { useEffect } from "react"
import mixpanel from "mixpanel-browser"

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  track_pageview: true,
  persistence: "localStorage",
})

const handleBeforeUnload = () => {
  mixpanel.stop_session_recording()
}

// TO REVIEW: DON'T RETURN children. Return null instead.
export default function MixPanelProvider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [])

  return children
}
